import { type EventFeedback } from 'models';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, message } from 'ui';
import { EventFeedbackForm } from './components';
import { useCreateEventFeedaback } from './queries';

type P = {
  isOpened: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  eventId: string;
};

export const CreateEventFeedback: FC<P> = ({ onSuccess, onCancel, isOpened, eventId }) => {
  const { t } = useTranslation();
  const { isLoading: isCreatingEventFeedback, mutate: createEventFeedback } = useCreateEventFeedaback();

  const onSubmit = async (data: EventFeedback) =>
    createEventFeedback(
      { id: eventId, data },
      {
        onSuccess() {
          message.success('Thank you for your feedback.');
          onSuccess();
        },
        onError(error) {
          message.error(error.response?.data.message ?? 'Failed to send feedback.');
        },
      },
    );

  return (
    <Modal
      title={t('Rate Event Experience')}
      isOpened={isOpened}
      onCancel={onCancel}
      maskClosable={false}
      width="small"
      disableBack
    >
      <EventFeedbackForm onSubmit={onSubmit} loading={isCreatingEventFeedback} onCancel={onCancel} />
    </Modal>
  );
};
